<template>
  <div id="home-parent" class="page-container">
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image parallax-img"
        style="background-image: url('img/background_0.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <img src="img/AE24_Logo_v1.png" class="title-logo"/>
          <div class="text-center">
            <h3>Autoteile und Zubehör - schnell, einfach und zuverlässig!</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h2 class="title">Willkommen bei <span class="title-red">Auto</span><span class="title-blue">Edge</span><span class="title-red">24</span></h2>
            <h4 class="description">
              Sparen Sie sich die aufwendige Suche nach dem passenden Ersatzteil!
              <br>
              Bei AutoEdge 24 kümmern wir uns darum: Sie nennen uns einfach Ihre Fahrzeugdaten - wir übernehmen den Rest.
            </h4>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 carousel-container">
            <el-carousel :height="carouselHeight" autoplay>
              <!--
              <el-carousel-item>
                <img class="d-block link" src="img/Sommerreifen.jpeg" alt="First slide" @click="goToTires()" />
              </el-carousel-item>
              -->
              <el-carousel-item>
                <img class="d-block link" src="img/Winterreifen.jpg" alt="First slide" @click="goToTires()" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block link" src="img/welcome_1.jpg" alt="First slide" @click="goToShop()" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block link" src="img/welcome_2.jpg" alt="Second slide" @click="goToShop()" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block link" src="img/welcome_3.jpg" alt="Third slide" @click="goToShop()" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block link" src="img/welcome_4.jpg" alt="Third slide" @click="goToShop()" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!--
        <div class="row">
          <div class="col-md-6">
            <div
              class="image-container image-left"
              style="background-image: url('img/login.jpg')"
            >
            </div>
          </div>
          <div class="col-md-5">
            <div
              class="image-container image-right"
              style="background-image: url('img/bg1.jpg')"
            ></div>
          </div>
        </div>
        -->
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h4 class="description">
              Jetzt kontaktieren und ein unverbindliches Angebot anfordern<br>
              <n-button type="primary" round @click="openWhatsapp()">
                <span class="mdi mdi-whatsapp"></span> +49 176 55980480
              </n-button>
              <br>
              <n-button type="primary" round @click="openEmail()">
                <span class="mdi mdi-email-outline"></span> kontakt@autoedge24.de
              </n-button>
            </h4>
          </div>
        </div>
        <div class="separator separator-primary"></div>
      </div>
    </div>
    <div class="section section-about-us background-img-wrapper">
      <div class="container">
        <div class="background-container" :class="{foreground: !secondForeground}">
          <img class="background-img" src="img/car_background_1.jpg" alt="very cool bg">
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Über uns</h2>
            <h4 class="description">
              Bei AutoEdge 24 dreht sich alles um eines:<br>
              Ersatzteile finden - einfach, schnell und passend.<br>
              <br>
              Wir wissen, wie zeitaufwendig die Suche nach den richtigen Autoteilen sein kann. Genau deshalb übernehmen wir das für Sie!<br>
              Sie schicken uns einfach Ihre HSN/TSN und Fahrgestellnummer, nennen die gewünschten Ersatzteile - und wir kümmern uns um den Rest.<br>
              <br>
              Ob Markenqualität oder preiswerte Alternative, wir finden das passende Teil für Ihr Fahrzeug.<br>
              Viele Artikel sind noch am selben Tag verfügbar oder innerhalb kürzester Zeit lieferbar.<br>
            </h4>
            <h4 class="description list">
              Unsere Philosophie ist einfach:<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Persönlicher Service statt Katalogsuche<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Schnelligkeit, Qualität und Zuverlässigkeit<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Ehrliche Beratung vom Fachmann
            </h4>
            <h4 class="description">
              Wir arbeiten mit namhaften Herstellern und Lieferanten zusammen, um Ihnen hochwertige Ersatzteile zu fairen Preisen anbieten zu können - ganz ohne komplizierte Teilelisten.<br>
              <br>
              <strong><span class="title-red">Auto</span><span class="title-blue">Edge</span><span class="title-red">24</span></strong> - Wir finden, was Ihr Auto braucht.
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Und so einfach geht's</h2>
              <video class="video" controls>
                <source src="vid/advertise.mp4" type="video/mp4">
                Your browser does not support the video tag.
              </video> 
          </div>
        </div>
      </div>
    </div>
    <div id="background-observer" class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Alles erledigt in nur 3 Schritten:</h2>
            <h4 class="description list">
              1. HSN/TSN und Fahrgestellnummer senden<br>
              2. Gewünschte Ersatzteile nennen<br>
              3. Unverbindliches Angebot erhalten
            </h4>
            <h4 class="description">
              <span class="mdi mdi-lightbulb-on-outline text-primary"></span> 
              <i class="text-primary"> Gut zu wissen:</i> Wir prüfen die Kompatibilität der Teile individuell für jedes Fahrzeug. Damit vermeiden Sie Fehlkäufe und sparen Zeit, Geld und Nerven.
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div id="second-background" class="section section-about-us background-img-wrapper">
      <div class="container">
        <div class="background-container" :class="{foreground: secondForeground}">
          <img class="background-img" src="img/car_background_2.jpg" alt="very cool bg">
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Autoteile in Markenqualität günstig bestellen</h2>
            <h4 class="description">
              Wir setzen auf die Qualität führender Hersteller wie Bosch, MANN-FILTER, ATE, LIQUI MOLY und viele mehr. So erhalten Sie Ersatzteile in Erstausrüsterqualität, wie sie auch in der Produktion von Fahrzeugen namhafter Marken wie Volkswagen, Mercedes oder Audi verbaut werden - nur eben günstiger.
              Viele Artikel sind am selben Tag verfügbar und können direkt bestellt oder abgeholt werden.
            </h4>
            <h4 class="description list">
              Wir bieten Ihnen:<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Ersatzteile in Markenqualität zu fairen Preisen<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Kostenlosen Versand innerhalb Deutschlands<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Persönliche Beratung und schnelle Abwicklung<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Rücknahme unverbauter, originalverpackter Teile
            </h4>
            <h4 class="description">
              Bei uns bekommen Sie keine anonyme Katalogsuche, sondern echten Service vom Fachmann.
              <br>
              <strong><span class="title-red">Auto</span><span class="title-blue">Edge</span><span class="title-red">24</span></strong> - Wir finden, was Ihr Auto braucht.
            </h4>
          </div>
        </div>
      </div>
    </div>
    <!--
    <div class="section section-team text-center">
      <div class="container">
        <h2 class="title">Das ist unser Team</h2>
        <div class="team">
          <div class="row">
            <div class="col-md-4">
              <div class="team-player">
                <img
                  src="img/avatar.jpg"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Natalja Boldt</h4>
                <p class="category text-primary">Zwesda</p>
                <p class="description">
                  Ich bin unsere Zwesda
                </p>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-twitter"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-instagram"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-facebook-square"></i
                ></a>
              </div>
            </div>
            <div class="col-md-4">
              <div class="team-player">
                <img
                  src="img/ryan.jpg"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Andreas Maranditsch</h4>
                <p class="category text-primary">Chef</p>
                <p class="description">
                  Krutoj tschuwak
                </p>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-twitter"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-linkedin"></i
                ></a>
              </div>
            </div>
            <div class="col-md-4">
              <div class="team-player">
                <img
                  src="img/eva.jpg"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Christian Keine Ahnung</h4>
                <p class="category text-primary">Praktikant</p>
                <p class="description">
                  Junge für alles
                </p>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-google-plus"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-youtube"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-twitter"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->
    <div class="section section-contact-us text-center">
      <div class="container">
        <div class="row">
          <div class="col-md-12 ml-auto mr-auto text-center">
            <img src="img/brands.jpeg" alt="Brands" />
          </div>
        </div>
        <h2 class="title">Kontakt</h2>
        <div class="row">
          <div class="col-lg-6 ml-auto mr-auto text-center">
            <h4 class="description">
              <span class="mdi mdi-map-marker-outline"></span> Unsere Adresse:<br>
              AutoEdge 24<br>
              Grüsener Str. 17a<br>
              35285 Gemünden
            </h4>
          </div>
          <div class="col-lg-6 ml-auto mr-auto text-center">
            <h4 class="description">
              <iframe src="https://maps.google.com/maps?q=autoedge+24+Grüsener+Str.+17a+35285+Gemünden&z=16&output=embed"
                allowfullscreen="allowfullscreen" 
                frameborder="0"
                :width="mapWidth"
                :height="mapHeight"
                data-gtm-yt-inspected-11="true" 
                style="border: 0px;">
              </iframe>
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 ml-auto mr-auto text-center">
            <h4 class="description">
              Sie haben Fragen oder benötigen Unterstützung bei der Teileauswahl?
              Dann kontaktieren Sie uns einfach - per Mail oder WhatsApp.
              Wir helfen Ihnen schnell und unkompliziert weiter.<br>

              <n-button type="primary" round @click="openWhatsapp()">
                <span class="mdi mdi-whatsapp"></span> +49 176 55980480
              </n-button>
              <br>
              <n-button type="primary" round @click="openEmail()">
                <span class="mdi mdi-email-outline"></span> kontakt@autoedge24.de
              </n-button>
            </h4>
            <h4 class="description">
              <strong><span class="title-red">Auto</span><span class="title-blue">Edge</span><span class="title-red">24</span></strong> - Wir finden, was Ihr Auto braucht.
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
import { Carousel, CarouselItem } from 'element-ui';
import Parallax from 'vue-parallaxy'
export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  created() {
    //window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    //window.removeEventListener("resize", this.myEventHandler);
  },
  mounted() {
    const options = {
      rootMargin: "0px",
      scrollMargin: "0px",
      threshold: [0, 0.25, 0.5, 0.75, 1.00],
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if(this.intersectionY > entry.boundingClientRect.y && entry.intersectionRatio >= 0.5) {
          this.secondForeground = true;
        } else if(this.previousRatio > entry.intersectionRatio
            && this.intersectionY < entry.boundingClientRect.y 
            && entry.intersectionRatio < 0.1) {
          this.secondForeground = false;
        }
        this.intersectionY = entry.boundingClientRect.y
        this.previousRatio = entry.intersectionRatio
      });
    }, options);

    const target = document.querySelector("#background-observer");
    observer.observe(target);

    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize); 
  },
  data() {
    return {
      secondForeground: false,
      intersectionY: 0,
      previousRatio: 0,
      mapWidth: "600px",
      mapHeight: "400px",
      carouselHeight: "300px",
    };
  },
  methods: {
    onResize() {
      let mapWidth = window.innerWidth - 10
      mapWidth = Math.min(mapWidth, 600)

      const mapHeight = mapWidth / 1.5

      this.mapWidth = mapWidth + 'px'
      this.mapHeight = mapHeight + 'px'

      const carouselContaner = document.getElementsByClassName("carousel-container")[0];
      let carouselWidth = carouselContaner.clientWidth
      carouselWidth = Math.min(carouselWidth, 800)
      this.carouselHeight = (carouselWidth / 1.5) + 'px'
    },
    openPhone: function() {
      window.location = "tel:+4917655980480";
    },
    openWhatsapp: function() {
      window.open("https://wa.me/4917655980480", "_blank");
    },
    openEmail: function() {
      window.location = "mailto:kontakt@autoedge24.de";
    },
    goToTires() {
      this.$router.push("/tires");
    },
    goToShop() {
      this.$router.push("/shop");
    }
  }
};
</script>
<style scoped>
.background-img-wrapper {
  background-color: #00000040 !important;

  .title {
    color: white !important;
  }
  .description {
    color: white !important;
    font-weight: normal !important;
  }
  .background-container {
    left: 0;
    bottom: 0;
    position: fixed;
    z-index: -2;
    width: 100vw;
    height: 100vh;

    .background-img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
}
.parallax-img {
  z-index: 0 !important;
}
.foreground {
  z-index: -1 !important;
}
.parallax-test {
  position: relative;
}
.list {
  text-align: left;
  margin-left: 100px;
}
.small-margin-bottom {
  margin-bottom: 5px;
}
.phone-btn {
  margin-bottom: 0 !important;
}
.opening-time {
  font-size: small;
}
img.link {
  cursor: pointer;
}
.link {
  color: white !important;
  text-decoration: underline;
}
iframe {
  width: 100%;
  height: auto;
  max-width: 100%; /* or whatever you want it to be */
  aspect-ratio: 4/3;
}
.video {
  width: auto;
  height: 90vh;
  max-width: 100%; /* or whatever you want it to be */
  aspect-ratio: 9/16;
}
.title-logo {
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;
  width: 80%;
  height: auto;
}

.carousel-container {
  max-width: 800px !important;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
